(function ($) {
    $.fn.delphiTrapezoid = function (optionsOrMethod) {

        var args = arguments;
        var opts;
        if (typeof optionsOrMethod === "string")
            this.each(function (_, element) {
                delphiTrapezoid.apply($(element), args);
            });
        else
            this.each(function (_, element) {
                var elt = $(element);
                initializePlugin.apply(elt, args);
                drawTrapezoid.apply(elt, args);
            });

        return this;
    };

    $.fn.delphiTrapezoid.defaults = {
        strokeSettings: {
            xs: { padding: 15, stroke: 4 },
            sm: { padding: 20, stroke: 5 },
            md: { padding: 28, stroke: 7 },
            lg: { padding: 35, stroke: 8 }
        },
        strokeColor: "#0000FF",
    };

    function initializePlugin(options) {
        opts = $.extend({}, $.fn.delphiTrapezoid.defaults, options);
    };

    function drawTrapezoid(options) {
        const $container = this; //$(".js-delphi-trapezoid-overlay");
        const $canvas = $container.find("canvas");
        const $pictureContainer = $container.find(".js-delphi-overlay-picture");
        const containerWidth = $container.width();
        const overlayImageHeight = $pictureContainer.height();
        $canvas.attr('width', containerWidth);
        $canvas.attr('height', overlayImageHeight);
        const ctx = $canvas.get(0).getContext('2d');
        const settings = isBreakpoint('xs') ? opts.strokeSettings.xs :
            isBreakpoint('sm') ? opts.strokeSettings.sm :
                isBreakpoint('md') ? opts.strokeSettings.md :
                    opts.strokeSettings.lg;
        ctx.clearRect(0, 0, containerWidth, overlayImageHeight);
        ctx.beginPath();
        ctx.lineWidth = settings.stroke;
        ctx.strokeStyle = opts.strokeColor;
        ctx.moveTo(settings.padding, settings.padding);
        ctx.lineTo(containerWidth - settings.padding, settings.padding);
        ctx.lineTo(containerWidth - settings.padding, overlayImageHeight - (3 * settings.padding));
        ctx.lineTo(settings.padding, overlayImageHeight - settings.padding);
        ctx.closePath();
        ctx.stroke();
    };



    function isBreakpoint(alias) {
        const windowsWith = $(window).width();
        if (windowsWith < 768) {
            return alias === 'xs';

        }
        else if (windowsWith >= 768 && windowsWith <= 992) {
            return alias === 'sm';
        }
        else if (windowsWith > 992 && windowsWith <= 1200) {
            return alias === 'md';
        }
        else {
            return alias === 'lg';
        }
    }

})(jQuery);

$(document).ready(function () {
    $(".js-delphi-trapezoid-overlay").delphiTrapezoid();

    $(window).resize(function () {
        $(".js-delphi-trapezoid-overlay").delphiTrapezoid();
    });
});



